import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormClient({
  clientSelect,
  callback,
  title,
  button_text,
  button_variant,
  packages,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    id_client: '',
    phone: '',
    email: '',
    notify: false,
    access_app: false,
    state: true,
    cpass: '',
    nit_associate: '',
    address: '',
    type: '',
    package_id: '',
  });

  const handleClose = () => setShow(false);
  const handleShow = async (client) => {
    if (client) {
      const infoclient = await get('/client/' + client);
      if (infoclient.success) {
        let array_nit_associate = [];
        const { name, id_client, phone, email, notify, access_app, state, cpass, nit_associate, address, type, package_id } = infoclient.data;
        for (let i = 0; i < nit_associate.length; i++) {
          const element = nit_associate[i];
          array_nit_associate.push(element.id_client);
        }

        setForm({
          name,
          id_client,
          phone,
          email,
          notify,
          access_app,
          state,
          cpass,
          address,
          type,
          nit_associate: array_nit_associate.join(','),
          package_id,
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    e.preventDefault();
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm };
    console.log(body);
    if (clientSelect) {
      respo = await put('/client/modify/' + clientSelect, body);
      msg = 'Cliente editado Correctamente';
    } else {
      respo = await post('/client/create', body);
      msg = 'Cliente creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      id_client: '',
      phone: '',
      email: '',
      notify: false,
      access_app: false,
      state: true,
      cpass: '',
      nit_associate: '',
      address: '',
      type: '',
      package_id: '',
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => { };
    initForm();
  }, []);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(clientSelect)}
      />

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form onSubmit={(e) => saveForm(e)}>
              <Form.Label htmlFor="id_client">Nit</Form.Label>
              <Form.Control
                name="id_client"
                value={infoForm.id_client}
                onChange={(e) => handleForm(e)}
                type="text"
                required
              />
              <Form.Label htmlFor="nombre">Nombre</Form.Label>
              <Form.Control
                name="name"
                value={infoForm.name}
                onChange={(e) => handleForm(e)}
                type="text"
                required
              />
              <Form.Label htmlFor="phone">Telefono</Form.Label>
              <Form.Control
                name="phone"
                value={infoForm.phone}
                onChange={(e) => handleForm(e)}
                type="text"
                required
              />
              <Form.Label htmlFor="email">Correo Electronico</Form.Label>
              <Form.Control
                name="email"
                value={infoForm.email}
                onChange={(e) => handleForm(e)}
                type="email"
                required
              />
              <Form.Label htmlFor="address">Direccion</Form.Label>
              <Form.Control
                name="address"
                value={infoForm.address}
                onChange={(e) => handleForm(e)}
                type="address"
                required
              />

              <Form.Label htmlFor="ciudad">Tipo Cliente</Form.Label>
              <Form.Select
                name="type"
                value={infoForm.type}
                onChange={(e) => handleForm(e)}
                aria-label="Default select example"
              >
                <option value="">Seleccione</option>
                <option value="PARTICULAR">PARTICULAR</option>
                <option value="CONCESIONARIO">CONCESIONARIO</option>

              </Form.Select>

              <Form.Label htmlFor="nit_associate">Nit Asociados</Form.Label>
              <Form.Control
                name="nit_associate"
                value={infoForm.nit_associate}
                onChange={(e) => handleForm(e)}
                type="text"
              />

              <Form.Check
                type="switch"
                name="notify"
                label="Notificar Peritajes"
                checked={infoForm.notify}
                onChange={(e) => handleForm(e)}
              />

              <Form.Check
                type="switch"
                name="access_app"
                label="Accesso a plataforma"
                checked={infoForm.access_app}
                onChange={(e) => handleForm(e)}
              />

              <Form.Check
                type="switch"
                name="state"
                label="Activo"
                checked={infoForm.state}
                onChange={(e) => handleForm(e)}
              />

              {infoForm.access_app && (
                <Fragment>
                  <Form.Label htmlFor="cpass">
                    Contraseña acceso plataforma
                  </Form.Label>
                  <Form.Control
                    name="cpass"
                    value={infoForm.cpass}
                    onChange={(e) => handleForm(e)}
                    type="password"
                    required
                  />
                  <Form.Label htmlFor="ciudad">Paquete de servicios</Form.Label>
                  <Form.Select
                    name="package_id"
                    value={infoForm.package_id}
                    onChange={(e) => handleForm(e)}
                    aria-label="Default select example"
                  >
                    <option value="">Seleccione</option>
                    {packages.map((pkg) => (
                      <option key={pkg.id} value={pkg.id}>
                        {pkg.name}
                      </option>
                    ))}
                  </Form.Select>
                </Fragment>
              )}

              <Row className="text-center m-3">
                <Col>
                  <Button variant="secondary">Limpiar Formulario</Button>
                </Col>
                <Col>
                  <Button
                    type="submit"
                    variant="primary"
                  >
                    Guardar Informacion
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormClient;
